import * as AddDataSourceActionTypes from 'automation-ui-formula-editor/fetch-object-panel/actions/AddDataSourceActionTypes';
import { SelectRecordBy } from 'automation-ui-formula-editor/fetch-object-panel/containers/fields/utils/selectRecordBy';
import { DataSourceType, RecordFilterTypes } from 'automation-ui-formula-editor/data-passing-panel/types/dataSourcesTypes';
export const AddDataSourceInitState = {
  label: '',
  objectTypeId: null,
  dataSourceType: DataSourceType.FETCHED_OBJECT,
  // spec'd to be used for other types of data source creation to the BE
  recordFilterDefinition: {
    associationId: null,
    recordFilterType: null,
    // will be used when we introduce CRM filter, property match, etc.
    filterTargetType: 'ONE',
    selectRecordBy: SelectRecordBy.MOST_RECENTLY_UPDATED,
    associationTimestampOrder: null,
    propertyName: null,
    matchingValue: null
  }
};
export default function addDataSourceReducer(state, action) {
  var _action$selectRecordB;
  switch (action.type) {
    case AddDataSourceActionTypes.SELECT_TARGET_OBJECT_TO_ADD:
      return Object.assign({}, state, {
        objectTypeId: action.objectTypeId,
        recordFilterDefinition: Object.assign({}, state.recordFilterDefinition, {
          associationId: null,
          recordFilterType: null,
          filterTargetType: 'ONE',
          selectRecordBy: SelectRecordBy.MOST_RECENTLY_UPDATED,
          propertyName: null,
          matchingValue: null
        })
      });
    case AddDataSourceActionTypes.SELECT_FILTER_RECORD_BY:
      return Object.assign({}, state, {
        recordFilterDefinition: Object.assign({}, state.recordFilterDefinition, {
          recordFilterType: action.recordFilterType,
          filterTargetType: 'ONE',
          selectRecordBy: SelectRecordBy.MOST_RECENTLY_UPDATED,
          propertyName: null,
          matchingValue: null
        })
      });
    case AddDataSourceActionTypes.SELECT_ASSOCIATION_ID:
      return Object.assign({}, state, {
        recordFilterDefinition: Object.assign({}, state.recordFilterDefinition, {
          associationId: action.associationId
        })
      });
    case AddDataSourceActionTypes.SELECT_SORT_BY:
      return Object.assign({}, state, {
        recordFilterDefinition: Object.assign({}, state.recordFilterDefinition, {
          filterTargetType: action.selectRecordBy ? 'ONE' : 'MANY',
          selectRecordBy: (_action$selectRecordB = action.selectRecordBy) !== null && _action$selectRecordB !== void 0 ? _action$selectRecordB : null,
          associationTimestampOrder: null
        })
      });
    case AddDataSourceActionTypes.SELECT_SORT_BY_ASSOCIATION_TIMESTAMP:
      return Object.assign({}, state, {
        recordFilterDefinition: Object.assign({}, state.recordFilterDefinition, {
          filterTargetType: 'ONE',
          recordFilterType: RecordFilterTypes.ASSOCIATION_TIMESTAMP,
          selectRecordBy: SelectRecordBy.MOST_RECENTLY_UPDATED,
          associationTimestampOrder: action.associationTimestampOrder
        })
      });
    case AddDataSourceActionTypes.SELECT_MATCHING_DATA_SOURCE_PROPERTY:
      return Object.assign({}, state, {
        recordFilterDefinition: Object.assign({}, state.recordFilterDefinition, {
          propertyName: action.propertyName,
          matchingValue: null
        })
      });
    case AddDataSourceActionTypes.SELECT_MATCHING_ENROLLED_PROPERTY:
      return Object.assign({}, state, {
        recordFilterDefinition: Object.assign({}, state.recordFilterDefinition, {
          matchingValue: {
            type: 'ENROLLED_RECORD_FIELD',
            fieldName: action.propertyName
          }
        })
      });
    case AddDataSourceActionTypes.SELECT_MATCHING_PROPERTY_VALUE:
      return Object.assign({}, state, {
        recordFilterDefinition: Object.assign({}, state.recordFilterDefinition, {
          matchingValue: {
            type: 'STATIC',
            value: action.value
          }
        })
      });
    case AddDataSourceActionTypes.RENAME_DATA_SOURCE:
      return Object.assign({}, state, {
        label: action.label
      });
    default:
      return state;
  }
}